import Checkbox from '@mui/material/Checkbox';
import React, {
  memo,
  useContext,
} from 'react';
import { DataContext } from 'BaseComponents/HDataTable/DataContextProvider';
import { styled } from '@mui/material/styles';


const StickyTd = styled('td')({
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: '#fff',
  width: 25,
});

export const HSelectHeadCell = memo(() => {
  const {
    rows,
    selectAll,
    handleOnSelectRow,
    multiSelect,
  } = useContext(DataContext);

  if (!multiSelect) return null;

  return (
    <StickyTd>
      <Checkbox
        checked={selectAll}
        onChange={(e) => handleOnSelectRow(e?.target?.checked ?? false, rows, 'SELECT_ALL')}
      />
    </StickyTd>
  );
});

HSelectHeadCell.displayName = 'HSelectHeadCell';
